import type { AllocatableClass } from '@/types/allocation';

/**
 * The subjects one section teaches: the class's list, narrowed to the section's
 * own choice where the office made one. The server applies the same rule to
 * every write, so this only decides what a picker offers.
 */
export function subjectsOfSection(
  instituteClass: AllocatableClass,
  section: AllocatableClass['sections'][number],
): AllocatableClass['subjects'] {
  if (!section.subjectUuids) return instituteClass.subjects;
  const chosen = new Set(section.subjectUuids);
  return instituteClass.subjects.filter((subject) => chosen.has(subject.uuid));
}
